import { Box, Chip, IconButton, styled, Typography, useTheme } from '@mui/material';
import React from 'react';
import { Close } from '@mui/icons-material';
import { CustomChip } from '../CustomChip';
import { useLocation, useNavigate } from 'react-router-dom';

const AddedCompanyInfoBox = styled(Box)(({ theme }) => ({
    borderRadius: `${theme.typography.borderRadius.xxSmall}`,
    background: theme.palette.brandPrimary[50],
    padding: `${theme.typography.generic.xxSmall} ${theme.typography.generic.medium}`,
    margin: `${theme.typography.generic.xxxLarge} ${theme.typography.generic.none}`,

    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',

    width: 'fit-content',
}));

/**
 * ShowAddedCompanyBox - Component shows selectedCompanyList of company name by which filter done
 * @param {*} param0
 * @returns
 */
function ShowAddedCompanyBox({ selectedCompanyList = [], onRemoveCompany = (e1, e2) => {}, sx = {}, ...props }) {
    const theme = useTheme();

    const navigate = useNavigate();
    const location = useLocation();

    const companyRemoveHandler = (company) => {
        const remainingList = selectedCompanyList.filter((cItem) => {
            return cItem.id !== company.id;
        });

        // Create URLSearchParams
        const searchParams = new URLSearchParams(location.search);
        const filters = searchParams.getAll('filter'); // Returns an array

        if (filters.find((cCompanyId) => cCompanyId === company.id)) {
            searchParams.delete('filter', company.id || '');
            navigate(`${location.pathname}?${searchParams.toString()}`);
        } else {
            // navigate(`${location.pathname}?${searchParams.toString()}`);
        }

        // remainingList.forEach((cCompany) => searchParams.append('filter', cCompany.id || ''));
        // navigate(`${location.pathname}?${searchParams.toString()}`);

        onRemoveCompany && onRemoveCompany(company, remainingList);
    };

    if (!selectedCompanyList?.length) {
        return null;
    }

    return (
        <AddedCompanyInfoBox sx={{ ...sx }} {...props}>
            <Typography component={'span'} color={'text.secondary'} fontSize={'customFontSize.small'} fontWeight={'fontWeightRegular'} marginRight={theme.typography.generic.xxSmall}>
                Company:
            </Typography>

            <Typography component={'p'} color={'text.secondary'} fontSize={'customFontSize.small'} fontWeight={'fontWeightMedium'}>
                {selectedCompanyList.map((cItem, index) => (
                    <CustomChip
                        key={index}
                        label={cItem.name}
                        onDelete={() => companyRemoveHandler(cItem)}
                        sx={{
                            margin: '0.125rem',
                            '&:last-child': {
                                marginRight: '0rem',
                            },
                        }}
                    >
                        {/* {index !== 0 && ', '} {cItem.name} */}
                    </CustomChip>
                ))}
            </Typography>
            {/* <IconButton
                onClick={()=>removeCompanyHandler()}
                sx={{
                    padding: 0,
                    marginLeft: '0.5rem',
                    '& svg': {
                        fontSize: {
                            xs: '1.2rem',
                        },
                    },
                }}
            >
                <Close />
            </IconButton> */}
        </AddedCompanyInfoBox>
    );
}

export default ShowAddedCompanyBox;
